module.exports = __webpack_public_path__ + "media/application/images/2018/popup-close-2-1e706416fb11e3bf545aec9d3dc6e7ef.svg";